import { Component } from '@theme/component';

export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;
      if (videoSource) source.setAttribute('src', videoSource);
    }

    videoElement.muted = true;
    videoElement.defaultMuted = true;
    videoElement.playsInline = true;

    // Only add the fallback button to this specific section.
    const targetSection = this.closest(
      '#shopify-section-template--21405058334810__section_npVphq'
    );

    const content = targetSection?.querySelector(
      '.custom-section-content'
    );

    let playButton;

    if (content) {
      content.querySelector('[data-background-play]')?.remove();

      if (getComputedStyle(content).position === 'static') {
        content.style.position = 'relative';
      }

      playButton = document.createElement('button');
      playButton.type = 'button';
      playButton.dataset.backgroundPlay = '';
      playButton.textContent = 'Play video';
      playButton.hidden = true;
      playButton.setAttribute('aria-label', 'Play background video');

      Object.assign(playButton.style, {
        position: 'absolute',
        bottom: '12px',
        right: '12px',
        zIndex: '100',
        pointerEvents: 'auto',
        padding: '10px 16px',
        minHeight: '44px',
        border: '1px solid currentColor',
        borderRadius: '4px',
        background: '#D9B68A',
        color: '#222815',
        cursor: 'pointer'
      });

      content.appendChild(playButton);

      playButton.addEventListener('click', async () => {
        try {
          videoElement.muted = true;
          await videoElement.play();
          playButton.hidden = true;
        } catch {
          playButton.hidden = false;
          playButton.textContent = 'Try playing again';
        }
      });

      videoElement.addEventListener('playing', () => {
        playButton.hidden = true;
      });
    }

    videoElement.load();

    const playback = videoElement.play();
    if (playback) {
      playback.catch(() => {
        if (playButton) playButton.hidden = false;
      });
    }
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define(
    'video-background-component',
    VideoBackgroundComponent
  );
}
